/**
 * Shared focus treatment.
 *
 * DB-FR-010 / AC-56: focus must be visible on every interactive surface in both
 * themes. Centralising it means a new component cannot forget it, and the ring
 * colour is contrast-gated (`border-focus`, checked at 3:1 by tokens:contrast).
 */
export const focusRing =
  'outline-none focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2 focus-visible:ring-offset-surface-base'

/** For controls sitting on a raised surface, where the offset must match. */
export const focusRingRaised =
  'outline-none focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2 focus-visible:ring-offset-surface-raised'

/** Inset variant for inputs, where an offset ring would clip inside a field group. */
export const focusRingInset =
  'outline-none focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-inset'
